import AnnexIcon from 'shared/icons/anex_logo.svg'
import FunSun from 'shared/icons/fs_logo.svg'
import Kompass from 'shared/icons/kompas_logo.svg'

export const TourOperators = {
  operator_anex: {
    key: 'operator_anex',
    icon: AnnexIcon,
  },
  operator_kompas: {
    key: 'operator_kompas',
    icon: Kompass,
  },
  operator_funsun: {
    key: 'operator_funsun',
    icon: FunSun,
  },
} as const

export const TourOperatorsList = Object.keys(TourOperators)?.map((key) => ({
  key: key,
  color: TourOperators[key as TourOperatorsTypes].icon,
}))

export type TourOperatorsTypes = keyof typeof TourOperators
